{
  "OPTIONAL": "Optional",
  "BOOLEAN": {
    "YES": "Ja",
    "NO": "Nein"
  },
  "URGENCY": {
    "HIGH": "Hoch",
    "LOW": "Niedrig"
  },
  "APP": {
    "VERSION": "Diese App läuft auf Version {version}"
  },
  "BUTTONS": {
    "NEXT": "Weiter",
    "SKIP": "Überspringen",
    "CONFIRM": "Bestätigen",
    "CLOSE": "Schließen",
    "CANCEL": "Abbrechen",
    "SHOW_ALL": "Alle anzeigen",
    "HIDE": "Ausblenden"
  },
  "FOOTER": {
    "HOME": "Home",
    "WORK": "Arbeit",
    "TOOLBOXES": "Werkzeuge",
    "PROFILE": "Profil"
  },
  "WORK": {
    "EMPTY_STATE_TITLE": "Noch keine Projekte",
    "EMPTY_STATE_MESSAGE": "Projekte werden bald erscheinen."
  },
  "HOME": {
    "PRODUCT_NAME": "i-LOP",
    "PRODUCT_NAME_BETA": "BETA",
    "CHECK_IN_STATUS": {
      "CHECKED_IN": "Eingecheckt",
      "CHECKED_OUT": "Ausgecheckt",
      "CHECK_IN": "Einchecken",
      "CHECK_OUT": "Auschecken"
    },
    "TO_FULFILL": "Zu erledigen",
    "CHECKLISTS": "Checklisten",
    "CERTIFICATES": "Zertifikate",
    "SAFETY_INSTRUCTIONS": "Sicherheitsanweisungen",
    "TOOLBOXES": "Toolboxen",
    "NOT_ASSIGNED_TO_PROJECT": {
      "TITLE": "Kein aktives Projekt",
      "MESSAGE": "Sie sind noch nicht für ein Projekt registriert. Finden Sie ein Projekt, um zu beginnen!",
      "BUTTON": "Projekt finden"
    },
    "ALERTS": "Nachrichten",
    "NO_ALERTS": "Aktuell gibt es keine Nachrichten",
    "CURRENT_CHECK_IN": "Aktuell eingecheckt",
    "LAST_PROJECT": "Letztes Projekt",
    "CHECKED_IN_AT": "Eingecheckt um {time}",
    "LAST_CHECKED_IN": "Zuletzt eingecheckt um {time}",
    "CHECKED_OUT_AT": "Ausgecheckt um {time}",
    "FOREMAN": {
      "WORKERS_ON_SITE": "Mitarbeiter auf der Baustelle",
      "START_WORK_INSTRUCTION": "Start Werk Instructie",
      "CREATE": "+ Anlegen"
    }
  },
  "SAFETY_INSTRUCTIONS": {
    "TITLE": "Sicherheitsanweisungen",
    "ALL_COMPLETED": "Alle erforderlichen Sicherheitsanweisungen sind abgeschlossen"
  },
  "SAFETY_INSTRUCTION": {
    "PREVIOUS": "Zurück",
    "NEXT": "Weiter",
    "FINISH": "Fertig",
    "QUESTION_HINT_AT_LEAST_ONE": "Bitte wählen Sie mindestens eine richtige Antwort",
    "QUESTION_HINT_ALL_CORRECT": "Bitte wählen Sie alle richtigen Antworten",
    "QUESTION_ERROR_ALL_CORRECT": "Dies sind nicht die richtigen Antworten, bitte versuchen Sie es erneut",
    "QUESTION_CORRECT": "Richtige Antwort!",
    "QUESTION_ERROR_UNANSWERED": "Bitte geben Sie für alle Fragen die richtigen Antworten an, bevor Sie fortfahren"
  },
  "LOGIN": {
    "EMAIL_LABEL": "E-Mail",
    "PASSWORD_LABEL": "Passwort",
    "EMAIL_PLACEHOLDER": "Geben Sie Ihre E-Mail-Adresse ein",
    "PASSWORD_PLACEHOLDER": "Geben Sie Ihr Passwort ein",
    "LOGIN_BUTTON": "Anmelden",
    "LOG_IN": "Anmelden",
    "FORGOT_PASSWORD": "Passwort vergessen?",
    "LOGIN_WITH_YIVI": "Mit Yivi anmelden",
    "YIVI_HELP": "Verwenden Sie Yivi, um sich anzumelden oder Ihr Konto zu erstellen.",
    "PASSWORD_LOGIN": "Mit Passwort anmelden"
  },
  "FORGOT_PASSWORD": {
    "TITLE": "Passwort vergessen",
    "DESCRIPTION": "Geben Sie Ihre E-Mail-Adresse ein, damit wir Ihnen eine E-Mail zur Passwort-Wiederherstellung senden können",
    "EMAIL_LABEL": "E-Mail",
    "EMAIL_PLACEHOLDER": "Geben Sie Ihre E-Mail-Adresse ein",
    "SUCCESS_MESSAGE_1": "Wir haben eine Bestätigungs-E-Mail gesendet an",
    "SUCCESS_MESSAGE_2": "Überprüfen Sie Ihre E-Mail und klicken Sie auf den Bestätigungslink, um fortzufahren",
    "SUBMIT_BUTTON": "Senden",
    "RESEND_BUTTON": "E-Mail erneut senden"
  },
  "RESET_PASSWORD": {
    "TITLE": "Passwort zurücksetzen",
    "DESCRIPTION": "Erstellen Sie ein neues, starkes Passwort, das Sie nicht für andere Websites verwenden",
    "PASSWORD_LABEL": "Neues Passwort",
    "PASSWORD_PLACEHOLDER": "Geben Sie Ihr neues Passwort ein",
    "VERIFY_PASSWORD_LABEL": "Neues Passwort bestätigen",
    "VERIFY_PASSWORD_PLACEHOLDER": "Geben Sie Ihr neues Passwort erneut ein",
    "PASSWORD_MISMATCH": "Passwörter stimmen nicht überein",
    "RESET_BUTTON": "Passwort zurücksetzen",
    "INVALID_TOKEN": "Die E-Mail-Adresse ist ungültig oder der Token ist abgelaufen. Bitte fordern Sie eine neue Passwort-Zurücksetzung an",
    "SUCCESS_TITLE": "Erfolgreich!",
    "SUCCESS_MESSAGE": "Ihr Passwort wurde erfolgreich zurückgesetzt. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.",
    "LOGIN": "Anmelden",
    "INVALID_LINK_TITLE": "Ungültiger Reset-Link",
    "INVALID_LINK_MESSAGE": "Dieser Passwort-Reset-Link ist ungültig oder abgelaufen. Bitte fordern Sie eine neue Passwort-Zurücksetzung an.",
    "REQUEST_NEW_LINK": "Neuen Reset-Link anfordern"
  },
  "ACCEPT_INVITATION": {
    "INTRO": {
      "TITLE": "Einladung",
      "DESCRIPTION": "Sie wurden zu einer Anstellung eingeladen. Prüfen Sie die Details und akzeptieren Sie die Einladung, um zu beginnen.",
      "SUBSCRIPT": "Dieser Einladungslink kann nur einmal verwendet werden und läuft in 7 Tagen ab.",
      "BUTTON": "Einladung annehmen"
    },
    "OFFER": {
      "ORGANISATION": "Organisation",
      "FUNCTION": "Funktion",
      "START_DATE": "Startdatum",
      "END_DATE": "Enddatum",
      "INVITED_AS": "Eingeladen als"
    },
    "ACCEPT_ON_PHONE": {
      "TITLE": "Auf Ihrem Telefon annehmen",
      "DESCRIPTION": "Scannen Sie diesen Code mit der Kamera Ihres Telefons, um diese Einladung in der i-LOP App zu öffnen."
    },
    "SIGN_IN_TO_ACCEPT": "Zum Annehmen anmelden",
    "SUCCESS": {
      "TITLE": "Einladung angenommen!",
      "DESCRIPTION": "Ihre Anstellung ist jetzt mit Ihrem Konto verknüpft.",
      "BUTTON": "Weiter"
    },
    "ALREADY_ACCEPTED": {
      "TITLE": "Bereits angenommen",
      "DESCRIPTION": "Diese Einladung wurde bereits angenommen."
    },
    "NOT_INVITABLE": {
      "TITLE": "Einladung nicht mehr gültig",
      "DESCRIPTION": "Dieses Arbeitsverhältnis ist nicht mehr verfügbar. Bitte wenden Sie sich an Ihren Arbeitgeber."
    },
    "EXPIRED": {
      "TITLE": "Einladung abgelaufen",
      "DESCRIPTION": "Dieser Einladungslink ist abgelaufen. Bitten Sie Ihren Arbeitgeber, eine neue Einladung zu senden."
    },
    "INVALID_LINK": {
      "TITLE": "Ungültiger Einladungslink",
      "DESCRIPTION": "Dieser Einladungslink ist ungültig. Wenden Sie sich an Ihren Administrator, um eine neue Einladung anzufordern."
    }
  },
  "ERRORS": {
    "AUTHENTICATION": {
      "USER_ALREADY_EXISTS": "E-Mail-Adresse wird bereits verwendet",
      "INVALID": "Ihre E-Mail-Adresse oder Ihr Passwort ist falsch",
      "TRY_LATER": "Sie können sich momentan nicht anmelden, bitte versuchen Sie es später erneut",
      "TOKEN_NOT_VALID": "Sie müssen sich erneut anmelden",
      "YIVI_FAILED": "Beim Anmelden mit Yivi ist ein Fehler aufgetreten"
    },
    "PROJECT_SELECT": {
      "ALREADY_ASSIGNED": "Sie sind bereits diesem Projekt zugewiesen.",
      "NOT_ASSIGNED": "Sie sind diesem Projekt nicht zugewiesen."
    },
    "QRCODE_SCANNER": {
      "NO_PERMISSION": "Keine Berechtigung zur Nutzung der Kamera",
      "INVALID": "Der QR-Code ist ungültig",
      "EXPIRED": "Der QR-Code ist abgelaufen",
      "NO_PROJECT_SELECTED": "Wähle zuerst das Projekt, für das du prüfen möchtest",
      "NO_PROJECT_TO_VERIFY": "Du leitest hier kein Projekt, daher gibt es kein Projekt, für das diese Person geprüft werden kann",
      "PROJECTS_UNAVAILABLE": "Deine Projekte konnten nicht geladen werden. Prüfe deine Verbindung und scanne erneut",
      "IDENTITY_NOT_RESOLVED": "Der QR-Code gehört zu keinem einzelnen App-Konto"
    },
    "AVATAR": {
      "TOO_LARGE": "Die Fotodatei ist zu groß. Wählen Sie ein kleineres Foto.",
      "DIMENSIONS_TOO_LARGE": "Das Foto ist zu groß. Wählen Sie ein kleineres Foto.",
      "UNSUPPORTED_IMAGE_TYPE": "Dieser Dateityp kann nicht als Profilbild verwendet werden. Wählen Sie ein JPEG-, PNG- oder WebP-Bild.",
      "MALFORMED_IMAGE": "Das Foto konnte nicht gelesen werden. Versuchen Sie ein anderes Foto.",
      "INVALID_IMAGE": "Das Foto kann nicht als Profilbild verwendet werden."
    },
    "GENERIC": "Etwas ist schief gelaufen",
    "NETWORK": "Keine Verbindung zum Server möglich",
    "NOT_FOUND": "Etwas konnte nicht gefunden werden",
    "UNKNOWN": "Ein unbekannter Fehler ist aufgetreten",
    "OFFLINE": "Sie sind nicht online",
    "NOT_CHECKED_IN": "Sie sind nicht in ein Projekt eingecheckt",
    "CONTENT_OUTSTANDING": "Schließe alle Anweisungen und Toolboxen ab, bevor du unterschreibst.",
    "INVALID_SIGNATURE": "Diese Unterschrift konnte nicht gelesen werden. Zeichne sie erneut.",
    "NO_PROJECT_ACCESS": "Sie haben keinen Zugriff auf dieses Projekt",
    "NO_ACCESS": "Sie haben dafür keine Berechtigung",
    "INVITATION_INVALID": "Der Einladungslink ist ungültig.",
    "INVITATION_EXPIRED": "Der Einladungslink ist abgelaufen. Bitten Sie Ihren Arbeitgeber, einen neuen zu senden.",
    "EMPLOYMENT_ALREADY_ACCEPTED": "Diese Anstellung ist bereits mit einem anderen Konto verknüpft.",
    "EMPLOYMENT_NOT_INVITABLE": "Diese Anstellung kann nicht mehr angenommen werden.",
    "PERSON_BINDING_CONFLICT": "Dieser Personendatensatz ist mit einem anderen App-Konto verknüpft. Wenden Sie sich an Ihren Administrator.",
    "GATE_ENTRY_REQUIRES_EXCEPTION": "Diese Person erfüllt nicht alle Anforderungen, der Zutritt muss als Ausnahme erfasst werden.",
    "PERSON_NOT_BOUND": "Diese Person hat noch kein App-Konto.",
    "PERSON_NO_PROJECT_ACCESS": "Die gescannte Person hat keinen Zugriff auf dieses Projekt",
    "PERSON_ALREADY_CHECKED_IN": "Die gescannte Person ist bereits in dieses Projekt eingecheckt",
    "SUBJECT_NOT_FOUND": "Das Konto der gescannten Person wurde nicht gefunden",
    "SUBJECT_NOT_CHECKED_IN": "Diese Person ist in diesem Projekt nicht eingecheckt und kann hier nicht zugelassen werden"
  },
  "QRCODE_SCANNER": {
    "TITLE": "Scannen",
    "SCAN_QR_CODE": "QR-Code scannen",
    "RETRY_SCAN_QR_CODE": "QR-Code erneut scannen",
    "CAMERA_PERMISSION_DENIED_EXPLANATION": "Öffnen Sie die Einstellungen und geben Sie die Berechtigung zur Nutzung der Kamera",
    "OPEN_SETTINGS": "Einstellungen öffnen",
    "SCAN_AGAIN": "Nächsten scannen",
    "VERIFY_AGAINST": "Prüfen für Projekt",
    "VERIFY_AGAINST_PLACEHOLDER": "Projekt wählen"
  },
  "SELECT": {
    "DEFAULT_TITLE": "Option auswählen",
    "DEFAULT_MULTISELECT_TITLE": "Eine oder mehrere Optionen auswählen"
  },
  "ONBOARDING": {
    "LOG_IN": "Anmelden",
    "WELCOME_MESSAGE": "Willkommen auf der Lern- und Entwicklungsplattform."
  },
  "YIVI_REGISTRATION": {
    "TITLE": "Vervollständigen Sie Ihr Konto",
    "DESCRIPTION": "Wir haben Ihre Identitätsdaten von Yivi erhalten. Vervollständigen Sie die verbleibenden iLOP-Informationen, um fortzufahren.",
    "BIRTH_DATE": "Geburtsdatum",
    "GENDER": "Geschlecht",
    "SUBMIT": "Konto erstellen",
    "CANCEL": "Abbrechen"
  },
  "GENDER": {
    "MALE": "Männlich",
    "FEMALE": "Weiblich",
    "OTHER": "Andere"
  },
  "SAVED_WORK": {
    "BUTTON_TITLE": "Gespeichert"
  },
  "NOTIFICATION": {
    "DISMISS": "Schließen"
  },
  "PROFILE": {
    "PERSONAL_INFORMATION": "Persönliche Informationen",
    "NAME": "Vorname",
    "SURNAME": "Nachname",
    "NICKNAME": "Rufname",
    "NICKNAME_PLACEHOLDER": "Gib deinen Rufnamen ein (optional)",
    "CERTIFICATES": "Zertifikate",
    "SAVE": "Speichern",
    "SELECT_FUNCTION": "Funktion auswählen",
    "LOGOUT": "Abmelden",
    "TOAST": {
      "SAVED": "Persönliche Informationen wurden gespeichert",
      "ERROR": "Ein Fehler ist beim Speichern der persönlichen Informationen aufgetreten"
    },
    "AVATAR": {
      "ACTION_SHEET_TITLE": "Was möchten Sie tun?",
      "CHANGE_LABEL": "Profilbild ändern",
      "DELETE_LABEL": "Profilbild löschen",
      "CANCEL_LABEL": "Abbrechen",
      "RESIZE_ERROR": "Das Foto konnte nicht verarbeitet werden. Versuchen Sie ein anderes Foto.",
      "CROP_TITLE": "Foto zuschneiden",
      "CROP_CONFIRM": "Foto verwenden",
      "CROP_ZOOM_LABEL": "Zoomen"
    },
    "SETTINGS": "Einstellungen",
    "SETTINGS_ROUTES": {
      "CHANGE_PASSWORD": "Passwort ändern"
    },
    "PASSWORD": {
      "LABEL_CURRENT": "Aktuelles Passwort",
      "PLACEHOLDER_CURRENT": "Geben Sie Ihr aktuelles Passwort ein",
      "LABEL_NEW": "Neues Passwort",
      "PLACEHOLDER_NEW": "Geben Sie Ihr neues Passwort ein",
      "LABEL_VERIFY_NEW": "Neues Passwort bestätigen",
      "PLACEHOLDER_VERIFY_NEW": "Geben Sie Ihr neues Passwort erneut ein",
      "BUTTON_LABEL": "Passwort ändern",
      "TOAST": {
        "SUCCESS": "Passwort wurde geändert. Melden Sie sich erneut mit Ihrem neuen Passwort an",
        "ERROR": "Ein Fehler ist beim Ändern des Passworts aufgetreten"
      },
      "FORM_VALIDATION_MISMATCH": "Die neuen Passwörter stimmen nicht überein"
    }
  },
  "PROJECT_DETAILS": {
    "TITLE": "Projektdetails",
    "SWI_SIGNED": "SWI unterschrieben",
    "SWI_OPEN": "SWI offen",
    "SWI_SIGNED_COUNT": "{count} SWI unterschrieben",
    "SWI_SIGNED_OF": "{signed} von {total} SWI unterschrieben",
    "REPORT_SAFETY_RISKS": "Sicherheitsrisiken melden",
    "SEE_SAFETY_REPORTS": "Sicherheitsmeldungen öffnen",
    "CONTRACTOR": "Auftragnehmer",
    "CLIENT": "Kunde",
    "SELECT": "Auswählen",
    "WORKERS": "Arbeiter",
    "DESELECT": "Abwählen",
    "WORKERS_EMPTY_STATE": "Noch keine Arbeiter haben sich für dieses Projekt registriert.",
    "UNKNOWN_EMPLOYER": "Arbeitgeber unbekannt",
    "CERTIFICATES": "Erforderliche Projektzertifikate",
    "TOOLBOXES": "Erforderliche Projekt-Toolboxes",
    "TOOLBOXES_ALL_COMPLETED": "Alle erforderlichen Toolboxes sind abgeschlossen",
    "ALERTS": "Nachrichten",
    "CREATE_ALERT": "Nachricht hinzufügen",
    "ALERTS_EMPTY_STATE": "Aktuell gibt es keine Nachrichten für dieses Projekt",
    "MAIN_OFFICE": "Hauptbüro",
    "CHECK_IN": "Einchecken",
    "CHECK_OUT": "Auschecken",
    "AT_WORK": "{count} bei der Arbeit",
    "REQUIREMENTS_CHECKLIST": "Projektanforderungen",
    "OVERWRITE_CHECKIN_TITLE": "Einchecken",
    "OVERWRITE_CHECKIN_MESSAGE": "Sie sind derzeit bei \"{projectName}\" eingecheckt. Wenn Sie hier einchecken, wird dieser Check-in beendet.",
    "OVERWRITE_CHECKIN_CONFIRM": "Einchecken",
    "OVERWRITE_CHECKIN_CANCEL": "Abbrechen"
  },
  "PROJECT_SELECT": {
    "TITLE": "Projekt auswählen",
    "PROJECT_NAME": "Projektname",
    "PROJECT_FUNCTION": "Funktion im Projekt",
    "SELECT_AT_LEAST_ONE_FUNCTION": "Wählen Sie mindestens eine Funktion aus.",
    "EMPLOYEE": "Mitarbeiter",
    "NEXT": "Weiter",
    "ALREADY_CHECKED_IN_TITLE": "Bereits eingecheckt",
    "ALREADY_CHECKED_IN_MESSAGE": "Sie sind bei diesem Projekt schon eingecheckt. Sie müssen nichts tun.",
    "INVALID_CODE": "Dieser Projektcode ist nicht mehr gültig. Fragen Sie den Bauleiter nach dem aktuellen Code.",
    "REPORT_TO_FOREMAN_TITLE": "Melden Sie sich beim Bauleiter",
    "REPORT_TO_FOREMAN_MESSAGE": "Sie sind eingecheckt, sind aber nicht für dieses Projekt registriert. Melden Sie sich sofort beim Bauleiter."
  },
  "PROJECT_SELECT_CONFIRM": {
    "ALL_FULFILLED": "Alle Anforderungen sind erfüllt",
    "BUTTON": "Bestätigen",
    "TITLE": "Projektauswahl bestätigen"
  },
  "PROJECT_SELECT_SUCCESS": {
    "SUCCESS": "Erfolgreich!",
    "SELECTED": "Sie haben sich für das Projekt registriert.",
    "DESELECTED": "Sie haben sich vom Projekt abgemeldet.",
    "BUTTON": "Home"
  },
  "CERTIFICATE": {
    "EXPIRED": "Abgelaufen am {date}",
    "VALID_UNTIL": "Gültig bis {date}",
    "EXPIRES_IN": "Läuft ab in {duration}",
    "EXPIRES_SOON": "Läuft innerhalb von 3 Monaten ab",
    "EXPIRES_NEVER": "Läuft nie ab",
    "MISSING": "Noch nicht erhalten",
    "PENDING": "Ausstehende Prüfung",
    "REJECTED": "Abgelehnt",
    "VIEW_DOCUMENT": "Dokument",
    "VIEW_DOCUMENT_N": "Dokument {n}",
    "REGISTERED_TO": "Registriert auf {name}"
  },
  "DOCUMENT_INPUT": {
    "ADD": "Foto oder PDF hinzufügen",
    "TAKE_PHOTO": "Foto aufnehmen",
    "CHOOSE_FROM_LIBRARY": "Aus Bibliothek wählen",
    "CHOOSE_PDF": "PDF wählen",
    "REMOVE": "Entfernen",
    "CANCEL": "Abbrechen"
  },
  "ADD_CERTIFICATE": {
    "TITLE": "Zertifikat hinzufügen",
    "CERTIFICATE": "Zertifikat",
    "CERTIFICATE_NUMBER": "Zertifikatnummer",
    "ISSUED_ON": "Ausgestellt am",
    "EXPIRES_ON": "Läuft ab am",
    "DOCUMENT": "Dokument",
    "MISSING_FIELDS": "Bitte Organisation und Zertifikat auswählen.",
    "ERROR": "Es ist ein Fehler aufgetreten. Bitte erneut versuchen.",
    "CHOOSER": {
      "IMPORT": "Aus Register importieren",
      "UPLOAD": "Dokument hochladen"
    }
  },
  "IMPORT_CERTIFICATE": {
    "TITLE": "Zertifikat importieren",
    "LAST_NAME": "Nachname",
    "DATE_OF_BIRTH": "Geburtsdatum",
    "REGISTRY": "Register",
    "CERTIFICATE_NUMBER": "Zertifikatnummer",
    "MISSING_FIELDS": "Bitte füllen Sie alle Felder aus.",
    "SUCCESS": "Zertifikat importiert.",
    "STATUS": {
      "NOTFOUND": "Für diese Angaben wurde kein Zertifikat gefunden.",
      "REGISTRYERROR": "Das Register konnte derzeit nicht erreicht werden. Bitte versuchen Sie es später erneut."
    }
  },
  "CERTIFICATES": {
    "NO_CERTIFICATES": "Keine Zertifikate gefunden",
    "EXPIRED_CERTIFICATES": "Einige Ihrer Zertifikate sind abgelaufen. Erneuern Sie sie, um weiter arbeiten zu können."
  },
  "MARKDOWN_CONTENT": {
    "TERMS_AND_CONDITIONS": "Allgemeine Geschäftsbedingungen",
    "PRIVACY_POLICY": "Datenschutzrichtlinie",
    "APP_INFO": "App-Informationen",
    "AVG_STATEMENT": "DSGVO-Erklärung"
  },
  "HUMANIZE_DURATION": {
    "MONTHS": "{count, plural, =1{Monat} other{Monate}}",
    "DAYS": "{count, plural, =1{Tag} other{Tage}}",
    "SOON": "bald"
  },
  "PERSON": {
    "FIRST_NAME": "Vorname",
    "LAST_NAME": "Nachname",
    "EMAIL": "E-Mail-Adresse",
    "FUNCTION": "Funktion"
  },
  "WORKER_PROFILE": {
    "FUNCTION": "Funktion",
    "PROJECT": "Aktuelles Projekt",
    "CERTIFICATES": "Zertifikate",
    "PROJECT_DETAILS": "Projektdetails",
    "UPDATE_PERSON_ACTION": "Details bearbeiten",
    "ASSIGN_TO_PROJECT_ACTION": "Zu meinem Projekt zuweisen"
  },
  "PHOTOS": {
    "PROFILE_PHOTO": "Profilbild auswählen",
    "CANCEL": "Abbrechen",
    "TAKE_PHOTO": "Foto aufnehmen",
    "CHOOSE_FROM_LIBRARY": "Aus Bibliothek auswählen"
  },
  "UMA": {
    "MY_REPORTS": {
      "TITLE": "Meine Meldungen",
      "EMPTY_STATE_TITLE": "Keine Meldungen",
      "EMPTY_STATE_MESSAGE": "Sicherheitsrisiken, die Sie selbst gemeldet haben, erscheinen hier.",
      "CREATE_REPORT": "Meldung erstellen"
    },
    "REPORT": {
      "ASSIGNED_TO": "Wird bearbeitet von {name}",
      "REPORTED_BY": "Gemeldet von {name}",
      "REPORTED_BY_ANONYMOUS": "Anonym gemeldet"
    },
    "PROJECT_REPORTS": {
      "TITLE": "Meldungen für {projectName}",
      "EMPTY_STATE_TITLE": "Keine Meldungen",
      "EMPTY_STATE_MESSAGE": "Sicherheitsrisiken, die für dieses Projekt gemeldet wurden, erscheinen hier."
    },
    "CANNOT_CREATE_REPORT": {
      "TITLE": "Meldung kann nicht erstellt werden",
      "DESCRIPTION": "Sie sind nicht für ein Projekt registriert. Registrieren Sie sich, um eine Meldung erstellen zu können."
    },
    "NEW_REPORT": {
      "CREATE_NEW_REPORT": "Meldung erstellen",
      "GENERAL": {
        "FORM_TITLE": "Allgemein",
        "CATEGORY": "Was möchten Sie melden?",
        "IS_SOLVED": "Ist es gelöst?",
        "IS_URGENT": "Dringlichkeit",
        "IS_ANONYMOUS": "Anonym melden",
        "PROJECT": "Für welches Projekt möchten Sie diese Meldung erstellen?",
        "NO_PROJECTS": "Sie sind nicht für ein Projekt registriert. Registrieren Sie sich, um eine Meldung erstellen zu können.",
        "CHOOSE_PROJECT": "Projekt auswählen",
        "CONFIRM_PROJECT": "Sie sind nicht für dieses Projekt registriert. Sind Sie sicher, dass Sie diese Meldung erstellen möchten?",
        "CONFIRM_PROJECT_BUTTON": "Ja, ich bin sicher",
        "VICTIMS": "Opfer?",
        "ABSENTEEISM": "Abwesenheit",
        "HOSPITALISED": "Krankenhausaufenthalt?",
        "HOSPITALISED_WARNING": {
          "BEFORE_PHONE": "IM FALL EINES SCHWEREN UNFALLS ODER EINER VERLETZUNG, DIE EINE HOSPITALISIERUNG ERFORDERT, RUFEN SIE IMMER ZUERST DEN NOTDIENST AN",
          "BETWEEN_PHONE_AND_URL": "ODER ÜBER DAS ONLINE-FORMULAR:",
          "AFTER_LINK": "Konsultieren Sie Ihren Vorgesetzten, den Vorarbeiter oder den V&G-Koordinator, der für diesen Bericht verantwortlich ist."
        }
      },
      "SITUATION": {
        "FORM_TITLE": "Situation",
        "PHOTOS": "Wie sieht die Situation aus?",
        "PHOTOS_PLACEHOLDER": "Fügen Sie ein oder mehrere Fotos hinzu oder geben Sie eine Beschreibung ein",
        "DESCRIPTION": "Beschreiben Sie die Situation",
        "SAFE_SITUATION_DESCRIPTION": "Sichere Situation",
        "RISK": "Risiko",
        "DESCRIPTION_OF_SITUATION": "Situationsbeschreibung",
        "ACTIONS_TAKEN": "Durchgeführte Maßnahmen",
        "RISK_CATEGORY": {
          "LABEL": "Risikokategorie",
          "PLACEHOLDER": "Kategorie auswählen",
          "REQUIRED": "Kategorie ist erforderlich"
        }
      },
      "SUMMARY": {
        "TITLE": "Meldung übermittelt",
        "MESSAGE": "Meldung mit der Nummer #{{id}} wurde übermittelt."
      },
      "SEND": "Senden",
      "SUCCESS_TOAST": "Sicherheitsmeldung erfolgreich erstellt",
      "VALIDATION": {
        "MISSING_FIELDS": "Bitte füllen Sie alle Pflichtfelder aus"
      }
    },
    "REPORT_DETAILS": {
      "NOT_ASSIGNED_TO": "Nicht einem Mitarbeiter zugewiesen",
      "ASSIGNED_TO_PERSON": "Zugewiesen an Mitarbeiter",
      "ASSIGN_TO_PERSON_PLACEHOLDER": "Mitarbeiter zuweisen",
      "DETAILS": "Details",
      "TITLE": "Meldung {reportId} anzeigen",
      "PROJECT_NAME": "Projekt",
      "REPORTER": "Melder",
      "ANONYMOUS_REPORTER": "Anonymer Melder",
      "UNKNOWN_AUTHOR": "Unbekannter Autor",
      "CATEGORY": "Meldungstyp",
      "URGENCY": "Dringlichkeit",
      "SOLVED": "Gelöst",
      "PHOTOS": "Fotos",
      "PHOTOS_EMPTY": "Diese Meldung enthält keine Fotos",
      "DESCRIPTION": "Beschreibung",
      "RISK": "Risiko",
      "CREATED_AT": "Erstellt am",
      "CREATE_COMMENT": "Kommentar schreiben",
      "COMMENTS": "Kommentare",
      "COMMENTS_EMPTY": "Es wurden noch keine Kommentare geschrieben",
      "COMMENT_BY": "Kommentar von {person}",
      "COMMENT_CREATED": "Kommentar erfolgreich geschrieben",
      "LOGS": "Protokolle",
      "LOGS_EMPTY": "Es gibt noch keine Protokolle",
      "LOG": {
        "CREATED": "Meldung erstellt von {actor}",
        "STATUS_CHANGED": "Status geändert zu {newStatus} von {actor}",
        "COMMENTED": "Kommentar geschrieben von {actor}"
      },
      "NOT_IN_PROJECT": "Melder war nicht für dieses Projekt registriert"
    }
  },
  "PUSH_NOTIFICATIONS": {
    "CLOSE": "Schließen",
    "OPEN": "Öffnen"
  },
  "REPORT_CATEGORY": {
    "ACCIDENT": "Unfall",
    "UNSAFE_SITUATION": "Unsicher",
    "SAFE_SITUATION": "Sicher"
  },
  "REPORT_STATUS": {
    "NEW": "Ungelesen",
    "IN_PROGRESS": "In Bearbeitung",
    "SOLVED": "Gelöst",
    "ON_HOLD": "Pausiert"
  },
  "NOTIFICATIONS": {
    "TITLE": "Benachrichtigungen",
    "EMPTY_STATE_TITLE": "Keine Benachrichtigungen",
    "EMPTY_STATE_MESSAGE": "Hier finden Sie alle wichtigen Benachrichtigungen aus Gegenwart und Vergangenheit",
    "NOTIFICATION_SENT_AT_FORMAT": "d MMMM HH:mm",
    "MARK_AS_READ": "Als gelesen markieren",
    "MARK_ALL_AS_READ": "Alle als gelesen markieren",
    "MARK_ALL_AS_READ_SUCCESS": "Alle Benachrichtigungen als gelesen markiert",
    "DELETE": "Löschen",
    "DELETE_SUCCESS": "Benachrichtigung gelöscht"
  },
  "REPORT_TRANSITION": {
    "NEW": "Zurück zu neu",
    "IN_PROGRESS": "In Bearbeitung nehmen",
    "SOLVED": "Als gelöst markieren",
    "ON_HOLD": "Pausieren",
    "SOLVED_CONFIRMATION_TITLE": "Meldung als gelöst markieren?",
    "SOLVED_CONFIRMATION_MESSAGE": "Sind Sie sicher, dass Sie diese Meldung als gelöst markieren möchten?"
  },
  "SPEECH_RECOGNITION": {
    "TITLE": "Sprechen Sie Ihren Text",
    "BTN_LABEL": "Text sprechen",
    "PERMISSION_ERROR": "Text sprechen nicht möglich. Keine Berechtigung erteilt. Öffnen Sie die Einstellungen Ihres Telefons und erteilen Sie die Berechtigung zum Sprechen von Text für diese App.",
    "LISTENING": "Hört zu...",
    "USE_RESULT": "Ergebnis eingeben"
  },
  "CERTIFICATE_LIST": {
    "MY_EMPTY_STATE": "Sie haben noch keine Zertifikate erhalten",
    "PERSON_EMPTY_STATE": "Dieser Mitarbeiter hat noch keine Zertifikate erhalten",
    "PROJECT_EMPTY_STATE": "Es gibt keine relevanten Zertifikate für dieses Projekt",
    "PERSON_PROJECT_EMPTY_STATE": "Es gibt keine relevanten Zertifikate für diesen Mitarbeiter in diesem Projekt"
  },
  "ALERT_CATEGORY": {
    "GENERAL": "Allgemein",
    "WEATHER": "Wetter",
    "LOGISTIC": "Logistik",
    "SAFETY": "Sicherheit"
  },
  "ALERT_DETAILS": {
    "EDIT": "Bearbeiten",
    "TITLE": "Nachrichtendetails",
    "CONFIRM": "Verstanden",
    "DELETE_TITLE": "Nachricht löschen",
    "DELETE_MESSAGE": "Sind Sie sicher, dass Sie diese Nachricht löschen möchten?",
    "DELETE_CONFIRM": "Löschen",
    "DELETE_SUCCESS": "Nachricht gelöscht"
  },
  "ALERT_PLAYER": {
    "PLAY": "Abspielen",
    "PAUSE": "Pausieren",
    "LANGUAGE": "Sprache",
    "SEEK": "Fortschritt",
    "FULLSCREEN": "Vollbild"
  },
  "ALERT": {
    "CATEGORY": "Kategorie",
    "TITLE": "Titel",
    "DESCRIPTION": "Beschreibung",
    "VALID_FROM": "Von",
    "VALID_UNTIL": "Bis",
    "FROM": "von",
    "UNTIL": "bis",
    "VIDEO": "Video",
    "REMOVE_VIDEO": "Video entfernen",
    "TYPE": "Nachrichtentyp",
    "TYPE_TEXT": "Text",
    "TYPE_VIDEO": "Video",
    "ADD_TARGET_AUDIENCE": "Zielgruppe hinzufügen",
    "TARGET_AUDIENCE": "Zielgruppe",
    "TARGET_AUDIENCE_EVERYONE": "Jeder",
    "TARGET_AUDIENCE_MANAGEMENT": "Führungskräfte",
    "SELECT_TARGET_AUDIENCE": "Zielgruppe auswählen",
    "NO_FILE_SELECTED": "Keine Datei ausgewählt",
    "CHOOSE_FILE": "Datei auswählen",
    "TRANSLATION": "Übersetzung",
    "TRANSLATION_DESCRIPTION": "Dieses Video übersetzen",
    "VIDEO_UPLOAD_FAILED": "Video-Upload fehlgeschlagen",
    "AUDIENCE": {
      "MANAGEMENT": "Führungskräfte",
      "ORGANISATION": "Organisation:",
      "FUNCTION": "Funktion:",
      "FUNCTION_GROUP": "Funktionsgruppe:",
      "ADD_MANAGEMENT": "Führungskräfte",
      "ADD_ORGANISATION": "Organisation",
      "ADD_FUNCTION": "Funktion oder Gruppe",
      "SELECT_ORGANISATION": "Organisation auswählen",
      "NO_ORGANISATIONS": "Keine Organisationen in diesem Projekt.",
      "LOADING_ORGANISATIONS": "Wird geladen..."
    }
  },
  "NEW_ALERT": {
    "TITLE": "Nachricht hinzufügen",
    "ACTION": "Nachricht erstellen",
    "SUCCESS_TOAST_MESSAGE": "Nachricht erfolgreich erstellt"
  },
  "EDIT_ALERT": {
    "TITLE": "Nachricht bearbeiten",
    "ACTION": "Änderungen speichern",
    "SUCCESS_TOAST_MESSAGE": "Nachricht erfolgreich aktualisiert"
  },
  "EDIT_PERSON_PROJECT": {
    "TITLE": "Projekt zuweisen",
    "SUCCESS_TOAST_MESSAGE": "Projektzuweisung erfolgreich aktualisiert"
  },
  "REASSIGN_PERSON_PROJECT": {
    "TITLE": "Projekt zuweisen",
    "SUCCESS_TOAST_MESSAGE": "Projektzuweisung erfolgreich"
  },
  "SELECT_UI": {
    "SEARCHBAR_PLACEHOLDER": "Nach Option suchen"
  },
  "CHECKLIST": {
    "COMPLETED": "Checkliste erfolgreich abgeschlossen",
    "ERROR": "Beim Abschließen der Checkliste ist etwas schiefgelaufen",
    "LIST_LABEL": "Checklisten",
    "ALL_COMPLETED": "Alle erforderlichen Checklisten sind abgeschlossen",
    "COMPLETE": "Abschließen"
  },
  "PASSWORD_COMPLEXITY": {
    "REQUIREMENTS": "Passwort-Anforderungen:",
    "MIN_LENGTH": "Mindestens {minLength} Zeichen",
    "UPPERCASE": "Mindestens ein Großbuchstabe",
    "LOWERCASE": "Mindestens ein Kleinbuchstabe",
    "DIGIT": "Mindestens eine Zahl",
    "SPECIAL_CHAR": "Mindestens ein Sonderzeichen"
  },
  "FUNCTION_SELECT": {
    "ROOT": "Stamm",
    "SEARCH_PLACEHOLDER": "Nach Funktion suchen",
    "NO_RESULTS": "Keine Funktionen gefunden",
    "WHOLE_CATEGORY": "Ganze Gruppe: {name}"
  },
  "WORKER_DETAIL": {
    "START_WORK_INSTRUCTION": "Start Werk Instructie",
    "SWI_SIGNED_ON": "Unterschrieben am {moment}",
    "NO_SWI_SIGNATURE": "Noch nicht unterschrieben",
    "SWI_SIGNATURE_ALT": "Unterschrift",
    "SWI_SIGNATURE_FAILED": "Die Unterschrift konnte nicht geladen werden",
    "TITLE": "Mitarbeiterdetails",
    "ITEM_STATUS": {
      "PRESENT": "Vorhanden",
      "MISSING": "Fehlt",
      "EXPIRED": "Abgelaufen",
      "EXPIRED_GRACE_PERIOD": "Abgelaufen (Kulanzfrist)"
    },
    "CERTIFICATES": "Zertifikate",
    "CHECKLISTS": "Checklisten",
    "SAFETY_INSTRUCTIONS": "Sicherheitsanweisungen",
    "TOOLBOXES": "Werkzeugkästen",
    "NAME": "Name",
    "VERIFIED_AGAINST": "Geprüft für {project}",
    "BASIC_INFORMATION": "Basisinformationen",
    "ILOP_CONTENT": "i-LOP-Inhalte",
    "NO_EMPLOYMENTS": "Dieser Mitarbeiter hat keine aktiven Beschäftigungen",
    "NO_ILOP_CONTENT": "Für diesen Mitarbeiter gibt es in diesem Projekt keine relevanten i-LOP-Inhalte",
    "CHECK_IN": {
      "SINCE": "Eingecheckt um"
    },
    "EMPLOYMENT": {
      "FUNCTION": "Funktion",
      "FROM": "Von",
      "TO": "Bis"
    },
    "CERTIFICATE": {
      "NUMBER": "Nummer",
      "ISSUED_ON": "Ausgestellt am",
      "ISSUED_FOR": "Ausgestellt für",
      "EXPIRES_ON": "Läuft ab am"
    },
    "CONTENT": {
      "COMPLETED_ON": "Abgeschlossen am",
      "MEETING_ENDED": "Besprechung beendet",
      "SIGNED": "Unterschrieben"
    },
    "KVK": {
      "NUMBER": "KvK-Nummer",
      "DOCUMENT_DATE": "Auszug vom",
      "VALID_UNTIL": "Gültig bis",
      "DOCUMENT": "KvK-Auszug"
    },
    "OPEN_DOCUMENT": "Öffnen",
    "OPEN_DOCUMENT_FAILED": "Das Dokument konnte nicht geöffnet werden"
  },
  "GATE_ENTRY": {
    "TITLE": "Zutritt erfassen",
    "GAPS_HINT": "Diese Person erfüllt nicht alle Anforderungen, der Zutritt ist deshalb eine Ausnahme.",
    "NOT_CHECKED_IN_HINT": "Diese Person ist in diesem Projekt nicht eingecheckt. Checken Sie sie ein, um sie zuzulassen, oder verweigern Sie den Zutritt.",
    "CHECK_IN_WORKER": "Person einchecken",
    "DECISION": {
      "VALID": "Gültig",
      "EXCEPTION": "Ausnahme",
      "DENIED": "Verweigert"
    },
    "REASON": {
      "HEADER_EXCEPTION": "Grund für die Ausnahme",
      "HEADER_DENIED": "Grund für die Verweigerung",
      "MESSAGE": "Dies wird mit deinem Namen und der Uhrzeit festgehalten.",
      "PLACEHOLDER": "Beschreibe den Grund",
      "CONFIRM": "Erfassen"
    },
    "REGISTERED": "Zutritt erfasst"
  },
  "EMPLOYMENT": {
    "TIMELINE": {
      "TITLE": "Beschäftigungsverlauf",
      "NO_EMPLOYMENTS": "Kein Beschäftigungsverlauf verfügbar.",
      "PRESENT": "Gegenwart",
      "ACTIVE": "Aktiv",
      "NOT_YET_ACTIVE": "Noch nicht aktiv",
      "LOAD_ERROR": "Beim Laden des Beschäftigungsverlaufs ist ein Fehler aufgetreten.",
      "STATUS_FOR_ADMIN_REVIEW": "In Prüfung",
      "STATUS_FOR_USER_REVIEW": "Überprüfen Sie Ihre Beschäftigung",
      "ADD_EMPLOYMENT": "Hinzufügen",
      "REVIEW_NOTICE": "Es gibt Beschäftigungen, die auf Ihre Überprüfung warten.",
      "REVIEW_NOTICE_ACTION": "Tippen Sie, um sie anzuzeigen und zu überprüfen.",
      "REVIEW_OPEN": "Prüfen",
      "REVIEW_DETAILS_TITLE": "Beschäftigung überprüfen",
      "FUNCTION": "Funktion",
      "START_DATE": "Startdatum",
      "END_DATE": "Enddatum",
      "MANAGERIAL": "Leitende Funktion",
      "YES": "Ja",
      "NO": "Nein",
      "ACCEPT": "Akzeptieren",
      "REJECT": "Ablehnen",
      "REVIEW_ACCEPT_SUCCESS": "Beschäftigung erfolgreich akzeptiert.",
      "REVIEW_REJECT_SUCCESS": "Beschäftigung erfolgreich abgelehnt.",
      "REVIEW_ERROR": "Beim Überprüfen der Beschäftigung ist ein Fehler aufgetreten."
    },
    "DETAIL": {
      "TITLE": "Beschäftigung",
      "NOT_FOUND": "Diese Beschäftigung konnte nicht gefunden werden."
    },
    "CREATE": {
      "TITLE": "Beschäftigung hinzufügen",
      "ORGANISATION": "Organisation",
      "SEARCH_ORGANISATION": "Organisation suchen",
      "NO_ORGANISATIONS": "Keine Organisationen gefunden.",
      "FUNCTION": "Funktion",
      "START_DATE": "Startdatum",
      "END_DATE": "Enddatum",
      "MANAGERIAL_LABEL": "Leitende Funktion",
      "BUSINESS_REGISTRY_NUMBER": "Handelsregisternummer",
      "SAVE": "Speichern",
      "SAVE_SUCCESS": "Beschäftigung erfolgreich hinzugefügt.",
      "SAVE_ERROR": "Beim Hinzufügen der Beschäftigung ist ein Fehler aufgetreten.",
      "LOAD_ORGANISATIONS_ERROR": "Beim Laden der Organisationen ist ein Fehler aufgetreten.",
      "END_DATE_BEFORE_START": "Das Enddatum darf nicht vor dem Startdatum liegen.",
      "ORGANISATION_UNAVAILABLE": "Dieser Arbeitgeber ist nicht mehr verfügbar. Wählen Sie einen anderen.",
      "FUNCTION_UNKNOWN": "Diese Funktion ist nicht mehr verfügbar. Wählen Sie eine andere.",
      "BINDING_CONFLICT": "Dieser Arbeitgeber kennt bereits jemanden mit Ihrer E-Mail-Adresse unter einem anderen Konto. Bitten Sie ihn stattdessen, Sie einzuladen.",
      "IDENTITY_INCOMPLETE": "In Ihrem Konto fehlt Ihr Name oder Ihre E-Mail-Adresse, daher kann ein Arbeitgeber Sie noch nicht registrieren. Melden Sie sich mit Yivi an, um dies zu vervollständigen.",
      "REQUEST_ALREADY_PENDING": "Sie haben bei diesem Arbeitgeber bereits eine offene Anfrage. Warten Sie auf dessen Antwort.",
      "INVITATION_PENDING": "Dieser Arbeitgeber hat Sie bereits eingeladen. Nehmen Sie diese Einladung in Ihrem Beschäftigungsverlauf an oder lehnen Sie sie ab."
    }
  },
  "TOOLBOXES": {
    "TABS": {
      "LIST": "Liste",
      "REGISTRATION": "Registrierung"
    },
    "EMPTY_STATE": "Keine Toolboxes verfügbar",
    "LAST_UPDATED": "Zuletzt aktualisiert",
    "VIEW_DOCUMENT": "Dokument anzeigen",
    "ASYNC": {
      "COMPLETED": "Toolbox abgeschlossen",
      "ERROR_COMPLETING": "Toolbox konnte nicht abgeschlossen werden"
    },
    "FOLLOWED": {
      "TITLE": "Absolvierte Toolboxes",
      "LINK": "Absolvierte Toolboxes anzeigen",
      "FILTER_CATEGORY": "Kategorie",
      "FILTER_TYPE": "Art",
      "TYPE_SYNCHRONOUS": "Synchron",
      "TYPE_ASYNCHRONOUS": "Asynchron",
      "TYPE_MANUAL": "Manuell",
      "NOT_AVAILABLE": "Nicht mehr verfügbar",
      "EMPTY_STATE": "Sie haben noch keine Toolboxes abgeschlossen",
      "EMPTY_FILTERED": "Keine absolvierten Toolboxes entsprechen diesen Filtern"
    },
    "MEETING": {
      "HOST_MEETING": "Toolbox-Meeting starten",
      "START_ANOTHER_TITLE": "Weiteres Meeting starten?",
      "START_ANOTHER_MESSAGE": "Sie haben bereits {count, plural, =1{ein Toolbox-Meeting} other{# Toolbox-Meetings}} laufen. Noch eines starten?",
      "START_ANOTHER_CONFIRM": "Weiteres starten",
      "ONLY_MANAGERIAL_CAN_HOST": "Nur Führungskräfte können ein Toolbox-Meeting leiten",
      "ONLY_MANAGERIAL_CAN_MANAGE": "Nur Führungskräfte können ein Toolbox-Meeting verwalten",
      "VIEW_ACTIVE_MEETING": "Aktives Meeting anzeigen",
      "SELECT_ACTIVE_MEETING": "Meeting auswählen",
      "MANUAL": {
        "START_BUTTON": "Manuelles Meeting starten",
        "DESCRIPTION": "Starten Sie als Manager ein neues manuelles Toolbox-Meeting für Ihr Team.",
        "START_TITLE": "Manuelles Meeting starten",
        "ORGANISATION": "Organisation",
        "ORGANISATION_PLACEHOLDER": "Organisation auswählen",
        "TITLE": "Titel",
        "TITLE_PLACEHOLDER": "Titel eingeben",
        "DESCRIPTION_PLACEHOLDER": "Optionale Beschreibung",
        "START_MISSING_FIELDS": "Bitte füllen Sie alle Pflichtfelder aus",
        "TITLE_REQUIRED": "Titel ist erforderlich",
        "TITLE_NOT_ALLOWED": "Der Titel kann nur bei manuellen Meetings geändert werden",
        "END_BEFORE_START": "Die Endzeit darf nicht vor der Startzeit liegen",
        "ACTIVE_LIST_TITLE": "Ihre Toolbox-Meetings",
        "ACTIVE_BADGE": "Läuft",
        "PLANNED_BADGE": "Geplant",
        "CONTINUE_BUTTON": "Mit diesem Meeting fortfahren"
      },
      "TITLE": "Toolbox-Meeting",
      "PARTICIPANTS": "Teilnehmende",
      "NO_PARTICIPANTS": "Noch keine Teilnehmer",
      "EXTERNAL_PARTICIPANT": "extern",
      "INFORMATION": "Informationen",
      "START_DATE": "Startdatum",
      "END_DATE": "Enddatum",
      "DESCRIPTION": "Beschreibung",
      "FINISH_MEETING": "Meeting beenden",
      "EDIT_MEETING": "Meeting bearbeiten",
      "SAVE": "Speichern",
      "CANCEL": "Abbrechen",
      "FINISH_CONFIRMATION_TITLE": "Meeting beenden?",
      "FINISH_CONFIRMATION_MESSAGE": "Möchten Sie dieses Toolbox-Meeting wirklich beenden?",
      "MEETING_ENDED_TITLE": "Meeting beendet",
      "MEETING_ENDED_MESSAGE": "Dieses Meeting wurde am {endTime} von {finishedByName} beendet",
      "MEETING_ALREADY_STARTED": "Ein Meeting wurde bereits von jemand anderem gestartet",
      "ERROR_POLLING_MEETING": "Beim Prüfen auf Meetings ist ein Fehler aufgetreten",
      "ERROR_STARTING_MEETING": "Meeting konnte nicht gestartet werden",
      "ERROR_LOADING_MEETING": "Meeting konnte nicht geladen werden",
      "ERROR_UPDATING_MEETING": "Meeting konnte nicht aktualisiert werden",
      "ERROR_FINISHING_MEETING": "Meeting konnte nicht beendet werden",
      "ERROR_END_BEFORE_START": "Die Endzeit darf nicht vor der Startzeit liegen",
      "SCAN_QR_CODE": "QR-Code scannen",
      "RETRY_SCAN": "Erneut scannen",
      "SCAN_TO_JOIN": "Scannen zum Beitreten",
      "JOIN_TOOLBOX_MEETING": "Toolbox-Meeting beitreten",
      "JOIN_DESCRIPTION": "Treten Sie einem bestehenden Toolbox-Meeting bei, indem Sie einen QR-Code scannen oder einen Meeting-Code eingeben.",
      "QR_SCAN_WRONG_MEETING": "Dieser QR-Code ist für ein anderes Meeting",
      "QR_SCAN_ALREADY_PARTICIPANT": "Sie sind bereits Teilnehmer an diesem Meeting",
      "QR_SCAN_INVALID": "Ungültiges QR-Code-Format",
      "QR_SCAN_ERROR": "Beim Scannen ist ein Fehler aufgetreten",
      "QR_SCAN_NO_PERMISSION": "Kameraberechtigung ist erforderlich, um QR-Codes zu scannen",
      "SUCCESSFULLY_JOINED": "Erfolgreich dem Meeting beigetreten",
      "ADD_PARTICIPANT": {
        "TITLE": "Teilnehmer hinzufügen",
        "CHOOSE_METHOD": "Wählen Sie, wie Sie einen Teilnehmer zu diesem Toolbox-Meeting hinzufügen möchten: Scannen Sie ihren i-LOP QR-Code oder geben Sie manuell einen Namen ein",
        "SCAN_QR_CODE": "QR-Code scannen",
        "MANUAL": "Manuell",
        "MANUAL_ENTRY": "Manuelle Eingabe",
        "OR": "oder",
        "FIRST_NAME": "Vorname",
        "LAST_NAME": "Nachname",
        "FIRST_NAME_PLACEHOLDER": "Vorname eingeben",
        "LAST_NAME_PLACEHOLDER": "Nachname eingeben",
        "CONFIRM": "Bestätigen",
        "ADDING": "Hinzufügen...",
        "SUCCESS": "Teilnehmer erfolgreich hinzugefügt",
        "ERROR": "Teilnehmer konnte nicht hinzugefügt werden",
        "MEETING_NOT_FOUND": "Meeting nicht gefunden",
        "ALREADY_PARTICIPANT": "Diese Person ist bereits Teilnehmer am Meeting",
        "MEETING_INACTIVE": "Das Meeting ist nicht aktiv",
        "QR_VERIFY_PERMISSION_ERROR": "Sie haben keine Berechtigung, diesen QR-Code zu überprüfen. Verwenden Sie stattdessen die manuelle Eingabe.",
        "MISSING_PARAMETERS": "Fehlende erforderliche Parameter für die Navigation",
        "NAVIGATION_ERROR": "Navigation zur Seite zum Hinzufügen von Teilnehmern fehlgeschlagen",
        "PERSON_NOT_IN_ORGANISATION": "Die gescannte Person gehört nicht zu Ihrer Organisation",
        "PERSON_NOT_BOUND": "Diese Person hat noch kein App-Konto. Fügen Sie sie stattdessen als externen Teilnehmer hinzu.",
        "PERSON_BINDING_CONFLICT": "Diese Person ist mit mehreren App-Konten verknüpft und kann nicht hinzugefügt werden. Wenden Sie sich an Ihren Administrator.",
        "NO_PERSON_RECORD": "Dieser Mitarbeiter hat ein Konto, ist aber noch bei keiner Organisation angestellt und kann daher nicht als Teilnehmer hinzugefügt werden. Fügen Sie ihn als externen Teilnehmer hinzu."
      }
    }
  },
  "SIGNATURE": {
    "TITLE": "Unterschrift",
    "INSTRUCTIONS": "Bitte unten unterschreiben",
    "CLEAR": "Löschen",
    "CONFIRM": "Bestätigen"
  },
  "PERSON_CHECKIN_CARD": {
    "CHECKED_IN_AT": "Eingecheckt um:",
    "LAST_CHECKED_OUT_AT": "Zuletzt ausgecheckt um:",
    "NOT_CHECKED_IN": "Nicht eingecheckt",
    "CERTIFICATES": "Zertifikate",
    "MORE_CERTIFICATES": "{count} weitere",
    "ADD_CERTIFICATE": "Zertifikat hinzufügen"
  },
  "ZZP_COMPANY": {
    "TITLE": "Firmenprofil (ZZP)",
    "INTRO": "Erstellen Sie ein Profil für Ihr Einzelunternehmen (ZZP).",
    "COMPANY_NAME": "Firmenname",
    "KVK_NUMBER": "Handelsregisternummer (KvK)",
    "SAVE": "Speichern",
    "TOAST": {
      "SAVED": "Firmenprofil wurde gespeichert",
      "ERROR": "Beim Speichern des Firmenprofils ist ein Fehler aufgetreten",
      "LOAD_ERROR": "Beim Laden des Firmenprofils ist ein Fehler aufgetreten"
    },
    "KVK_EXTRACT": {
      "LABEL": "KvK-Auszug",
      "ADD": "KvK-Auszug hinzufügen",
      "VIEW": "KvK-Auszug ansehen",
      "REMOVE": "Entfernen",
      "UPLOADED": "KvK-Auszug wurde hochgeladen",
      "REMOVED": "KvK-Auszug wurde entfernt",
      "INVALID_TYPE": "Nur PDF- oder Bilddateien sind zulässig",
      "DOCUMENT_DATE": "Datum auf dem KvK-Auszug",
      "VALID_UNTIL": "Gültig bis",
      "OUT_OF_DATE": "Dieser KvK-Auszug ist zu alt. Laden Sie einen aktuelleren hoch.",
      "NEEDS_DATE": "Geben Sie das Datum auf dem Auszug ein, damit er zählt.",
      "NEEDS_DOCUMENT": "Laden Sie den KvK-Auszug hoch, damit das Datum zählt."
    }
  },
  "START_WORK_INSTRUCTION": {
    "NEW_TITLE": "Neue SWI",
    "STEP_OF": "Schritt {step} von {total}",
    "NEXT": "Weiter",
    "LOADING": "Wird geladen…",
    "SAVED": "Start Werk Instructie gespeichert",
    "STEP_LABEL": {
      "PERIOD": "Datum oder Zeitraum",
      "MESSAGES": "Mitteilungen: Sicherheitsanweisungen von heute",
      "INSTRUCTIONS": "Anweisungen",
      "TOOLBOXES": "Toolboxen",
      "CHECKLISTS": "Checklisten",
      "SUMMARY": "Zusammenfassung",
      "NEW_MESSAGE": "Neue Nachricht"
    },
    "PERIOD": {
      "SINGLE_DAY": "Ein Tag",
      "RANGE": "Zeitraum",
      "DATE": "Datum",
      "FROM": "Von",
      "UNTIL_INCLUSIVE": "Bis einschließlich",
      "ONE_PER_DAY_HINT": "Pro Tag kann auf diesem Projekt nur eine SWI aktiv sein.",
      "TAKEN_DAYS_HINT": "Markierte Tage haben bereits eine SWI und können nicht gewählt werden.",
      "OVERLAP": "In diesem Zeitraum läuft bereits eine Start Werk Instructie. Wähle andere Daten."
    },
    "CONTENT": {
      "MESSAGES_HEADING": "Mitteilungen",
      "MESSAGES_HINT": "Es werden nur Mitteilungen des Typs Sicherheit angezeigt. Mehrere sind möglich.",
      "MESSAGES_EMPTY": "Keine aktuellen Sicherheitsmitteilungen in diesem Projekt.",
      "INSTRUCTIONS_HEADING": "Anweisungen",
      "INSTRUCTIONS_HINT": "Hier werden nur Inhalte angezeigt, die für eine SWI freigegeben sind.",
      "INSTRUCTIONS_EMPTY": "Keine Anweisungen für eine SWI verfügbar.",
      "TOOLBOXES_HEADING": "Toolboxen",
      "TOOLBOXES_HINT": "Hier werden nur Inhalte angezeigt, die für eine SWI freigegeben sind.",
      "TOOLBOXES_EMPTY": "Keine Toolboxen für eine SWI verfügbar.",
      "CHECKLISTS_HEADING": "Checklisten",
      "CHECKLISTS_HINT": "Hier werden nur Inhalte angezeigt, die für eine SWI freigegeben sind.",
      "CHECKLISTS_EMPTY": "Keine Checklisten für eine SWI verfügbar.",
      "MEDIUM_VIDEO": "Video",
      "MEDIUM_DOCUMENT": "Zu lesen"
    },
    "SUMMARY": {
      "CHANGE": "Ändern",
      "NOTHING_SELECTED": "Nichts ausgewählt",
      "NO_CONTENT": "Wähle mindestens eine Mitteilung, Anweisung, Toolbox oder Checkliste.",
      "SAVE": "Speichern",
      "PERIOD_SINGLE": "Start Werk Instructie vom {date}",
      "PERIOD_RANGE": "Start Werk Instructie vom {from} bis {to}"
    },
    "REPEAT": {
      "HEADING": "Wiederholung",
      "FIRST_ENTRY": "Nur beim ersten Betreten der Baustelle",
      "EVERY_ENTRY": "Jedes Mal beim Betreten der Baustelle",
      "AFTER_ABSENCE": "Nach einer Abwesenheit erneut befolgen",
      "ABSENCE_DAYS": "Länger als (Tage)",
      "ABSENCE_DAYS_RANGE": "Gib eine Zahl zwischen {min} und {max} ein."
    },
    "EDIT_TITLE": "SWI bearbeiten",
    "NEW_MESSAGE": {
      "ACTION": "Neue Nachricht (Text oder Video)",
      "OR_PICK": "Oder vorhandene Nachrichten auswählen",
      "HINT": "Zeitraum und Kategorie werden von der Start Werk Instructie übernommen.",
      "ADD": "Nachricht hinzufügen",
      "SAVE": "Nachricht speichern",
      "REMOVE": "Nachricht entfernen"
    },
    "FOLLOW": {
      "TITLE": "Start Werk Instructie",
      "INTRO": "Arbeite alles unten durch und unterschreibe anschließend.",
      "PROGRESS": "{done} von {total} erledigt",
      "EMPTY": "In diesem Projekt gibt es heute nichts zu befolgen.",
      "LOAD_FAILED": "Die Start Werk Instructie konnte nicht geladen werden.",
      "RETRY": "Erneut versuchen",
      "NEXT": "Nächster Schritt",
      "SIGN_INTRO": "Prüfe deine Angaben und unterschreibe.",
      "NAME": "Name",
      "DATE": "Datum",
      "COMPANY": "Firma",
      "FUNCTION": "Funktion",
      "CLEAR": "Löschen",
      "SIGN_AND_FINISH": "Unterschreiben und abschließen",
      "SIGNED": "Start Werk Instructie unterschrieben",
      "SIGN_FAILED": "Das Unterschreiben hat nicht geklappt. Versuche es erneut."
    },
    "CARD": {
      "HEADING": "Aktive Start Werk Instructie",
      "STATUS_ACTIVE": "Aktiv",
      "STATUS_PLANNED": "Geplant",
      "PERIOD_RANGE": "{from} bis {to}",
      "REPEAT_EVERY_ENTRY": "jedes Mal beim Betreten",
      "REPEAT_FIRST_ENTRY": "nur beim ersten Betreten"
    }
  }
}
